import { render } from "./DetailComponent3.vue?vue&type=template&id=68becc65&scoped=true"
import script from "./DetailComponent3.vue?vue&type=script&lang=js"
export * from "./DetailComponent3.vue?vue&type=script&lang=js"

import "./DetailComponent3.vue?vue&type=style&index=0&id=68becc65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68becc65"]])

export default __exports__